import create from "zustand";
import { devtools } from "zustand/middleware";

const store = create(
    devtools(
      (set) => ({
        imageUrl : "",
        setImageUrl: (url) => set({ imageUrl: url }),
      }),
      "Image"
    )
  );


export const useImageStore = () => [
    store((store) => store.imageUrl),
    store((store) => store.setImageUrl)
  ];

export default store;